import { AutogenModelBrkQualItem, AutogenRowBrkQualItem } from "./autogen/AutogenModelBrkQualItem";

export class ModelBrkQualItem extends AutogenModelBrkQualItem<RowBrkQualItem> {
	constructor() {
		super(RowBrkQualItem);
	}
}

export class RowBrkQualItem extends AutogenRowBrkQualItem {
}